/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-19 15:46:32
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-26 14:06:08
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductReview/ProductReviewDetail/Query/index.tsx
 */
import { SectionContent } from '@/src/layout/EditorPageLayout/EditorCollapsePageLayout';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _Query from 'src/constrains/Query1';
import { EnumFilterType } from 'src/constrains/Query1/Filter';
import { salesChannelFilter } from 'src/constrains/Query1/Filter/PreConfig/SalesChannel';
import { useI18n } from 'src/hooks/useRouterChange';
import { sortList } from 'src/pages/ProductReview/common';
import { i18nGet } from 'src/tools/tools';
import {
  getFilterSalesChannel,
  getSearchCondition,
  onFilterChange,
  onSearchChange,
  onSearchClose,
  onSortChange,
} from '../slice';
import css from './css.module.less';

const Query = () => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const _d = useDispatch();
  const _search = useSelector(getSearchCondition());
  const options = useSelector(getFilterSalesChannel());

  const filters = [
    {
      type: EnumFilterType.Range,
      prefixName: getI18n(
        'reviews.productreview.productReviewDetail_productInfo_genaral_ReviewPart_rating_title',
      ),
      keyWord: 'rating',
      dropdownProps: {
        name: getI18n(
          'reviews.productreview.productReviewDetail_productInfo_genaral_ReviewPart_rating_title',
        ),
        maxWidth: 400,
        maxHeight: 400,
      },
    },
    salesChannelFilter({
      options,
      dropdownName: getI18n(
        'reviews.productreview.productReviewDetail_Query_dropdownName',
      ),
      key: 'salesChannel',
    }),
  ];

  const handleOnSearchChange = (e) => {
    _d(onSearchChange(e));
  };
  const handleOnFilterChange = (e) => {
    _d(onFilterChange(e));
  };
  const handleOnSortChange = (e) => {
    _d(onSortChange(e));
  };

  const handleOnSearchClose = (e) => {
    _d(onSearchClose(e));
  };

  return (
    <SectionContent hasBottomBorder className={css.container}>
      <_Query
        onSearchChange={handleOnSearchChange}
        onFilterChange={handleOnFilterChange}
        onSortChange={handleOnSortChange}
        onTagClose={handleOnSearchClose}
        filters={filters}
        sortList={sortList({ getI18n })}
        data={_search}
      />
    </SectionContent>
  );
};
export default Query;
